export enum SearchCallTypes {
    QUICKADD = 'quickAdd',
    GENERALSEARCH = 'generalSearch',
    BROWSEFLOW = "browseFlow",
    CONTEXTUALSEARCH = 'contextualSearch'
}
